import { RouteModel, SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { GUID_, guids } from '@appShared/guids'

const baseUri = window.location.origin /* https://southwestern-dealertraining-web-portal-dev-as.azurewebsites.net */

export const environment = {
   production: false,
   isLocalDevelopment: false,
   apiConfig: {
      authorityDomain: 'devsecure.swfclearning.com',
      endpointUri: `${baseUri}/api`,
      msalConfig: {
         auth: {
            /* guids below used to obfuscate the clientId in PROD */
            /* Azure AD B2C → App registrations → (the LEAD Portal Web/SPA app) → Overview → Application (client) ID should equal f13dd577-6a7b-45c6-bb62-192a0161892a. */
            [guids.get(GUID_.B8C119E38553467B8ED361CB1AC821C5)]: '1cfc000a-ba84-452e-aa35-c71bb529023e'
         }
      },
      piiLoggingEnabled: true,
      scopes: [
         'https://swfcb2c.onmicrosoft.com/swfc-learning-portal-web-api/dev.subscription.manage',
         'https://swfcb2c.onmicrosoft.com/swfc-learning-portal-web-api/dev.content.subscribed'
      ],
      userFlows: {
         defaultSignIn: 'B2C_1_SWFC_Learning_Admin_SUSI_Fed_v1_dev',
         workAccountSignUpSignIn: 'B2C_1_SWFC_Learning_Admin_SUSI_Fed_v1_dev'
      }
   },
   appStore: {
      apple: 'https://apps.apple.com/us/app/southwestern-lead/id6478800540 ',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.southwestern.lead'
   },
   baseUri,
   dealerApiUri: 'https://devportal.advantage4dealers.com/api/dealer',
   playerUri: 'player',
   publicCdn: {
      uri: 'https://swfclearningprod.blob.core.windows.net/dealer-training',
      areaImagesFolder: 'area-images',
      courseImagesFolder: 'course-images',
      dashboardImagesFolder: 'dashboard-images',
      resourceImagesFolder: 'resource-images',
      badgeImagesFolder: 'badge-images'
   },
   internalUris: {
      academic_resources: {
         title: 'Academic Resources',
         uri: 'https://dev.advantage4teens.com',
      } as RouteModel,
      sales_portal: {
         title: 'Advantage4Dealers',
         uri: 'https://dev.advantage4dealers.com'
      } as RouteModel
   },
   routes: SITE_DIRECTORY_ROUTES,
   userPrincipalIdHeaderName: 'UserPrincipalId-29239E59E0924FC4',
   /* guids below used to obfuscate in PROD */
   [GUID_.C7F2A8E14B9D4E6FA3015D8B62C9E47A]: 'd1b94e62-5a37-48f9-9c10-7e4f6a8b2c5d', //cryptoSecretKey
   [GUID_.E567D0E4603F4A7580212E770DE079AA]: '9278211152072508',                 //serviceLayerClientId
   [GUID_.D9A8BADB30FA4EDE975EAE987AABFBD4]: '658921520779470c805211a288b7302e'  //serviceLayerClientSecret
}
